// removed by extract-text-webpack-plugin
module.exports = {"Label":"Label---1y4mD","TakeoverContent":"TakeoverContent---3nOkP","TakeoverPreview":"TakeoverPreview---nCH4R"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/shared/MessagePreviews/TakeoverMessage/TakeoverMessageBuilder/style.styl
// module id = Is47
// module chunks = 89